export type IconTileTone = "primary" | "accent" | "success" | "warning" | "error";

const ICON_TILE_CLASS: Record<IconTileTone, string> = {
  primary: "bg-primary-50 text-primary-600 ring-primary-600/15",
  accent: "bg-accent-50 text-accent-600 ring-accent-600/15",
  success: "bg-success-50 text-success-600 ring-success-600/15",
  warning: "bg-warning-50 text-warning-600 ring-warning-600/20",
  error: "bg-error-50 text-error-600 ring-error-600/15",
};

/**
 * Soft tinted icon tile (light background, tone-colored icon, hairline ring color).
 * Callers add `ring-1 ring-inset` plus size and radius.
 */
export function iconTileToneClass(tone: IconTileTone): string {
  return ICON_TILE_CLASS[tone];
}
